import React from 'react';

import { type NextPage } from 'next';

import { PageContainer } from '../components/index';

const theconnectedmagazine: NextPage = () => (
  <PageContainer>
    <section className="flex min-h-[80vh] items-center justify-center">
      <p className="animate-pulse text-2xl font-bold lg:text-6xl">
        Coming Soon
      </p>
    </section>
  </PageContainer>
);

export default theconnectedmagazine;
